export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  type: 'movie' | 'tv';
  region: string;
  year: number;
  genres: string[];
  rating: number;
  views: number;
  duration: string;
  director: string;
  actors: string[];
  synopsis: string;
  cover: string;
  backdrop?: string;
  dateAdded: string;
  tags: string[];
}

export const REGIONS: string[] = ['中国', '日本', '韩国', '泰国', '香港', '台湾'];

export const GENRES: string[] = [
  '爱情', '动作', '悬疑', '犯罪', '奇幻', '历史', '喜剧', '科幻', '恐怖', '剧情', '青春', '武侠',
];

export const YEAR_RANGES: { label: string; min: number; max: number }[] = [
  { label: '2025-2026', min: 2025, max: 2026 },
  { label: '2020-2024', min: 2020, max: 2024 },
  { label: '2015-2019', min: 2015, max: 2019 },
  { label: '2010-2014', min: 2010, max: 2014 },
  { label: '2000-2009', min: 2000, max: 2009 },
  { label: '更早', min: 1900, max: 1999 },
];

export const TYPE_LABELS: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  hot: '热门影视',
};

export const movies: Movie[] = [
  {
    id: 'm01',
    title: '长夜将明',
    originalTitle: 'Dawn After Long Night',
    type: 'movie',
    region: '中国',
    year: 2024,
    genres: ['悬疑', '犯罪', '剧情'],
    rating: 9.1,
    views: 9823000,
    duration: '126分钟',
    director: '陈砚舟',
    actors: ['段奕辰', '苏晚', '梁启明'],
    synopsis: '一桩尘封十五年的旧案在一场暴雨中重见天日，倔强的刑警队长与沉默的法医在蛛丝马迹里追寻真相。当所有人都以为凶手早已伏法，一条被忽略的线索却将两人引向更深的黑暗。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20asian%20crime%20thriller%20film%20poster%2C%20lone%20detective%20silhouette%20under%20heavy%20rain%20at%20night%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20dramatic%20lighting%2C%20atmospheric%20fog%2C%20high%20detail%2C%20editorial%20composition&width=400&height=600&seq=movie-01-cover&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20asian%20crime%20thriller%20scene%2C%20rain%20soaked%20narrow%20city%20alley%20at%20night%20with%20glowing%20amber%20streetlight%2C%20deep%20navy%20shadow%20tones%2C%20moody%20atmospheric%20fog%2C%20dramatic%20film%20lighting%2C%20high%20detail%20wide%20composition&width=1600&height=900&seq=movie-01-hero&orientation=landscape',
    dateAdded: '2024-11-08',
    tags: ['刑侦', '悬疑', '烧脑', '高分'],
  },
  {
    id: 'm02',
    title: '樱落之时',
    originalTitle: 'When Sakura Falls',
    type: 'movie',
    region: '日本',
    year: 2023,
    genres: ['爱情', '剧情'],
    rating: 8.7,
    views: 7215000,
    duration: '118分钟',
    director: '小林和也',
    actors: ['佐藤美咲', '中村悠斗', '田中莲'],
    synopsis: '在樱花纷飞的旧书店里，一位整理古籍的女孩与多年未归的旅人重逢。短暂的春天里，他们决定用一整个花期，把没能说出口的话讲完。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20romance%20film%20poster%2C%20young%20couple%20standing%20under%20blooming%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20and%20deep%20navy%20twilight%20tones%2C%20gentle%20warm%20backlight%2C%20dreamy%20atmospheric%2C%20high%20detail%20editorial%20composition&width=400&height=600&seq=movie-02-cover&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20romantic%20scene%2C%20sakura%20trees%20lining%20a%20quiet%20old%20street%20at%20dusk%2C%20petals%20drifting%20in%20soft%20wind%2C%20deep%20navy%20blue%20twilight%20with%20warm%20amber%20lantern%20glow%2C%20atmospheric%20high%20detail%20wide%20composition&width=1600&height=900&seq=movie-02-hero&orientation=landscape',
    dateAdded: '2023-12-02',
    tags: ['纯爱', '治愈', '樱花', '文艺'],
  },
  {
    id: 'm03',
    title: '首尔零度',
    originalTitle: 'Seoul Zero',
    type: 'movie',
    region: '韩国',
    year: 2025,
    genres: ['动作', '犯罪', '悬疑'],
    rating: 8.9,
    views: 11340000,
    duration: '134分钟',
    director: '朴俊浩',
    actors: ['李在勋', '金多恩', '崔敏俊'],
    synopsis: '一场发生在零下寒夜的连环劫案，让一个被停职的谈判专家重新踏入警局。他必须在天亮之前，识破这场精心设计、步步为营的完美犯罪。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20korean%20action%20crime%20film%20poster%2C%20determined%20man%20in%20dark%20coat%20standing%20in%20cold%20snowy%20city%20street%20at%20night%2C%20deep%20navy%20and%20amber%20neon%20reflections%2C%20gritty%20dramatic%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-03-cover&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20korean%20crime%20thriller%20scene%2C%20frozen%20modern%20seoul%20street%20at%20night%20with%20amber%20neon%20signs%20and%20snow%2C%20deep%20navy%20cold%20tones%2C%20tense%20dramatic%20film%20lighting%2C%20high%20detail%20wide%20composition&width=1600&height=900&seq=movie-03-hero&orientation=landscape',
    dateAdded: '2025-01-20',
    tags: ['犯罪', '警匪', '紧张', '高燃'],
  },
  {
    id: 'm04',
    title: '曼谷迷踪',
    originalTitle: 'Lost in Bangkok',
    type: 'movie',
    region: '泰国',
    year: 2022,
    genres: ['悬疑', '恐怖'],
    rating: 8.2,
    views: 5321000,
    duration: '109分钟',
    director: '差猜·瓦塔纳',
    actors: ['纳帕·颂希', '帕特·育塔', '阿南·贾'],
    synopsis: '一群背包客在曼谷老城区的旅店里发现了一本无人认领的日记。循着日记里的记述，他们一步步走进了一段不该被唤醒的往事。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20thai%20mystery%20horror%20film%20poster%2C%20old%20bangkok%20alley%20with%20flickering%20amber%20lanterns%20and%20heavy%20shadows%2C%20deep%20navy%20night%20tones%2C%20eerie%20atmospheric%20fog%2C%20suspenseful%20dramatic%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-04-cover&orientation=portrait',
    dateAdded: '2022-10-14',
    tags: ['恐怖', '异域', '氛围'],
  },
  {
    id: 'm05',
    title: '雾港往事',
    originalTitle: 'Harbor of Mist',
    type: 'movie',
    region: '香港',
    year: 2021,
    genres: ['犯罪', '剧情'],
    rating: 8.6,
    views: 6480000,
    duration: '121分钟',
    director: '麦志豪',
    actors: ['郑家豪', '林诗敏', '黄柏坚'],
    synopsis: '上世纪八十年代的维多利亚港，一个码头搬运工卷入两帮势力的旧账。在雾色弥漫的港口，他必须在兄弟情义与生存之间做出抉择。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20hong%20kong%20crime%20drama%20film%20poster%2C%20lone%20man%20in%20long%20coat%20on%20misty%20harbor%20pier%20at%20dawn%2C%20deep%20navy%20and%20muted%20amber%20tones%2C%20retro%20gritty%20dramatic%20lighting%2C%20atmospheric%20fog%2C%20high%20detail&width=400&height=600&seq=movie-05-cover&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20hong%20kong%20retro%20harbor%20scene%20at%20dawn%2C%20fishing%20boats%20and%20cranes%20shrouded%20in%20mist%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20sunrise%20glow%2C%20atmospheric%20moody%20film%20lighting%2C%20high%20detail%20wide%20composition&width=1600&height=900&seq=movie-05-hero&orientation=landscape',
    dateAdded: '2021-06-30',
    tags: ['年代', '港片', '兄弟'],
  },
  {
    id: 'm06',
    title: '河谷人家',
    originalTitle: 'People of the River Valley',
    type: 'tv',
    region: '中国',
    year: 2019,
    genres: ['历史', '剧情'],
    rating: 9.0,
    views: 8876000,
    duration: '全36集',
    director: '周怀山',
    actors: ['何守信', '柳青青', '吴国栋'],
    synopsis: '一条大河，三代人家。从动荡年代到烟火日常，河谷里的普通人家用最朴素的方式守护着土地与亲情，也见证着时代的更迭。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20chinese%20historical%20family%20drama%20poster%2C%20traditional%20riverside%20village%20at%20golden%20dusk%2C%20deep%20navy%20blue%20shadow%20tones%20with%20warm%20amber%20sunset%20glow%2C%20nostalgic%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-06-cover&orientation=portrait',
    dateAdded: '2019-09-18',
    tags: ['年代', '家庭', '史诗'],
  },
  {
    id: 'm07',
    title: '星尘旅人',
    originalTitle: 'Traveler of Stardust',
    type: 'movie',
    region: '日本',
    year: 2026,
    genres: ['科幻', '奇幻', '剧情'],
    rating: 8.8,
    views: 9560000,
    duration: '142分钟',
    director: '山田遥',
    actors: ['高桥优真', '石川爱', '森田匠'],
    synopsis: '地球最后的观测站里，一名孤独的技术员收到了一段来自四十光年外的信号。为了回应它，他踏上了一场跨越星海、也跨越内心的漫长旅程。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20sci%20fi%20film%20poster%2C%20lone%20astronaut%20before%20a%20vast%20glowing%20nebula%20window%2C%20deep%20navy%20cosmic%20tones%20with%20amber%20golden%20starlight%2C%20epic%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-07-cover&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20sci%20fi%20space%20scene%2C%20vast%20starfield%20and%20glowing%20nebula%20seen%20from%20orbital%20station%20window%2C%20deep%20navy%20cosmic%20background%20with%20warm%20amber%20starlight%2C%20epic%20atmospheric%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=movie-07-hero&orientation=landscape',
    dateAdded: '2026-02-11',
    tags: ['科幻', '太空', '治愈', '新片'],
  },
  {
    id: 'm08',
    title: '江南烟雨录',
    originalTitle: 'Record of Jiangnan Rain',
    type: 'tv',
    region: '中国',
    year: 2023,
    genres: ['武侠', '爱情', '历史'],
    rating: 8.5,
    views: 10420000,
    duration: '全40集',
    director: '沈凌云',
    actors: ['李文轩', '白清欢', '顾长风'],
    synopsis: '烟雨江南，一柄旧剑牵出江湖各派恩怨。退隐多年的侠客被迫重返武林，在执剑与守心之间，寻找那道真正值得奔赴的光。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20chinese%20wuxia%20costume%20drama%20poster%2C%20swordsman%20in%20flowing%20robe%20standing%20in%20rainy%20jiangnan%20canal%20town%2C%20deep%20navy%20and%20ink%20blue%20tones%20with%20warm%20amber%20lantern%20glow%2C%20moody%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-08-cover&orientation=portrait',
    dateAdded: '2023-07-05',
    tags: ['武侠', '古装', '江湖'],
  },
  {
    id: 'm09',
    title: '汉江之畔',
    originalTitle: 'Beside the Han River',
    type: 'tv',
    region: '韩国',
    year: 2024,
    genres: ['爱情', '剧情'],
    rating: 8.3,
    views: 7745000,
    duration: '全20集',
    director: '金泰妍',
    actors: ['韩智勋', '尹素拉', '朴宰民'],
    synopsis: '在汉江边经营着一间小咖啡馆的两个人，各自带着不肯提起的过去。四季流转，他们慢慢学会在对方的沉默里读懂温柔。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20korean%20romance%20drama%20poster%2C%20cozy%20cafe%20by%20the%20han%20river%20at%20blue%20hour%2C%20deep%20navy%20twilight%20tones%20with%20warm%20amber%20interior%20lights%2C%20gentle%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-09-cover&orientation=portrait',
    dateAdded: '2024-05-16',
    tags: ['都市', '治愈', '爱情'],
  },
  {
    id: 'm10',
    title: '霓虹之下',
    originalTitle: 'Beneath the Neon',
    type: 'tv',
    region: '日本',
    year: 2025,
    genres: ['悬疑', '犯罪'],
    rating: 8.7,
    views: 8310000,
    duration: '全24集',
    director: '藤原诚',
    actors: ['松本凉介', '桥本奈奈', '小野寺修'],
    synopsis: '东京最大的不夜城里，一条匿名举报牵出盘根错节的地下网络。年轻记者与执着的老刑警联手，在闪烁的霓虹之下揭开真相。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20neo%20noir%20crime%20drama%20poster%2C%20rainy%20tokyo%20neon%20street%20at%20night%20with%20reflections%2C%20deep%20navy%20tones%20with%20amber%20and%20coral%20neon%20glow%2C%20moody%20dramatic%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-10-cover&orientation=portrait',
    dateAdded: '2025-03-27',
    tags: ['犯罪', '记者', '都市'],
  },
  {
    id: 'm11',
    title: '热带心事',
    originalTitle: 'Tropical Hearts',
    type: 'movie',
    region: '泰国',
    year: 2023,
    genres: ['青春', '爱情', '喜剧'],
    rating: 8.0,
    views: 4103000,
    duration: '112分钟',
    director: '素拉·甘',
    actors: ['蓬·纳瓦', '妮达·查', '瓦林·颂'],
    synopsis: '毕业前的最后一个雨季，四个好朋友在海边小镇约定，要把所有没说出口的喜欢都讲出来。一场关于勇气与夏天的青春记。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20thai%20coming%20of%20age%20film%20poster%2C%20group%20of%20young%20friends%20on%20a%20tropical%20beach%20at%20golden%20sunset%2C%20deep%20navy%20sea%20with%20warm%20amber%20sunlight%2C%20youthful%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-11-cover&orientation=portrait',
    dateAdded: '2023-04-21',
    tags: ['青春', '夏日', '治愈'],
  },
  {
    id: 'm12',
    title: '台北的春天',
    originalTitle: 'Spring in Taipei',
    type: 'movie',
    region: '台湾',
    year: 2022,
    genres: ['剧情', '爱情'],
    rating: 8.4,
    views: 3980000,
    duration: '117分钟',
    director: '陈以宁',
    actors: ['林嘉豪', '许安琪', '吴柏宇'],
    synopsis: '一位准备离开台北的摄影师，在最后一个春天里重新走过这座城市的每一条街。他要找的，也许是照片，也许是自己。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20taiwanese%20city%20drama%20film%20poster%2C%20quiet%20taipei%20street%20with%20spring%20rain%20and%20old%20shophouses%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20window%20light%2C%20gentle%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-12-cover&orientation=portrait',
    dateAdded: '2022-03-11',
    tags: ['文艺', '城市', '治愈'],
  },
  {
    id: 'm13',
    title: '铁血长城',
    originalTitle: 'Iron Wall',
    type: 'movie',
    region: '中国',
    year: 2020,
    genres: ['历史', '动作'],
    rating: 8.1,
    views: 7630000,
    duration: '138分钟',
    director: '霍振东',
    actors: ['马啸', '罗铁', '叶清风'],
    synopsis: '边关告急，一支不足百人的守军必须在风雪之夜守住城墙。没有援军，没有退路，他们只有彼此与身后的万家灯火。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20chinese%20historical%20war%20film%20poster%2C%20armored%20soldier%20standing%20on%20a%20great%20wall%20in%20snowstorm%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20torch%20glow%2C%20epic%20dramatic%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-13-cover&orientation=portrait',
    dateAdded: '2020-12-25',
    tags: ['战争', '史诗', '家国'],
  },
  {
    id: 'm14',
    title: '月光下的约定',
    originalTitle: 'Promise Under the Moon',
    type: 'movie',
    region: '韩国',
    year: 2021,
    genres: ['爱情', '奇幻'],
    rating: 8.5,
    views: 5680000,
    duration: '115分钟',
    director: '郑恩珠',
    actors: ['车银瑞', '文荷娜', '李灿宇'],
    synopsis: '每逢满月，两人便能在旧桥上相见。可他们谁都不记得，这份约定究竟始于哪一年，又将在何时结束。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20korean%20fantasy%20romance%20film%20poster%2C%20couple%20holding%20hands%20on%20an%20old%20bridge%20under%20a%20huge%20moon%2C%20deep%20navy%20night%20tones%20with%20warm%20amber%20moonlight%2C%20dreamy%20atmospheric%20glow%2C%20high%20detail&width=400&height=600&seq=movie-14-cover&orientation=portrait',
    dateAdded: '2021-08-27',
    tags: ['奇幻', '浪漫', '治愈'],
  },
  {
    id: 'm15',
    title: '京都物语',
    originalTitle: 'Tales of Kyoto',
    type: 'movie',
    region: '日本',
    year: 2018,
    genres: ['剧情'],
    rating: 9.2,
    views: 6120000,
    duration: '124分钟',
    director: '河村诚一',
    actors: ['木村真', '宫泽咲', '冈田健'],
    synopsis: '一间百年和果子老铺，一位固执的老师傅，和三个想离开又想留下的学徒。京都的四季流转间，关于传承与和解的故事缓缓展开。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20quiet%20drama%20film%20poster%2C%20traditional%20kyoto%20courtyard%20with%20autumn%20maple%20and%20paper%20lanterns%2C%20deep%20navy%20shadow%20tones%20with%20warm%20amber%20light%2C%20serene%20atmospheric%20mood%2C%20high%20detail&width=400&height=600&seq=movie-15-cover&orientation=portrait',
    dateAdded: '2018-11-30',
    tags: ['家庭', '匠心', '高分'],
  },
  {
    id: 'm16',
    title: '港岛风云',
    originalTitle: 'Storm Over the Island',
    type: 'tv',
    region: '香港',
    year: 2024,
    genres: ['动作', '犯罪'],
    rating: 8.6,
    views: 9030000,
    duration: '全30集',
    director: '邓志伟',
    actors: ['陈柏豪', '蔡颖', '罗振业'],
    synopsis: '一桩卧底任务牵动整座港岛的暗流。警与匪、情与义，在灯火通明的都市丛林里交织成一场无法回头的博弈。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20hong%20kong%20action%20crime%20drama%20poster%2C%20man%20in%20dark%20suit%20standing%20on%20rooftop%20overlook%20neon%20city%20at%20night%2C%20deep%20navy%20tones%20with%20amber%20and%20coral%20neon%2C%20gritty%20dramatic%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-16-cover&orientation=portrait',
    dateAdded: '2024-08-19',
    tags: ['警匪', '卧底', '港剧'],
  },
  {
    id: 'm17',
    title: '沙漠之舟',
    originalTitle: 'Ship of the Desert',
    type: 'movie',
    region: '中国',
    year: 2017,
    genres: ['剧情', '历史'],
    rating: 8.3,
    views: 3540000,
    duration: '120分钟',
    director: '白川',
    actors: ['石磊', '乌兰', '苏日娜'],
    synopsis: '一支商队穿越千里戈壁，只为把一箱书送到荒漠尽头的村庄。风沙、干渴与未知的旅途里，最珍贵的是不肯熄灭的信念。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20chinese%20desert%20journey%20drama%20film%20poster%2C%20camel%20caravan%20crossing%20vast%20sand%20dunes%20at%20sunset%2C%20deep%20navy%20sky%20tones%20with%20warm%20amber%20desert%20glow%2C%20epic%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-17-cover&orientation=portrait',
    dateAdded: '2017-05-12',
    tags: ['公路', '信念', '史诗'],
  },
  {
    id: 'm18',
    title: '首尔惊魂夜',
    originalTitle: 'Night Terror in Seoul',
    type: 'movie',
    region: '韩国',
    year: 2026,
    genres: ['恐怖', '悬疑'],
    rating: 7.9,
    views: 4870000,
    duration: '104分钟',
    director: '申东哲',
    actors: ['姜河俊', '李娜英', '赵成浩'],
    synopsis: '搬进新公寓的第一个夜晚，住户们发现电梯总是停在从未存在的十三层。当好奇心战胜恐惧，噩梦才刚刚开始。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20korean%20horror%20film%20poster%2C%20eerie%20empty%20apartment%20corridor%20with%20flickering%20amber%20light%20and%20long%20shadows%2C%20deep%20navy%20cold%20tones%2C%20unsettling%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-18-cover&orientation=portrait',
    dateAdded: '2026-01-09',
    tags: ['恐怖', '惊悚', '新片'],
  },
  {
    id: 'm19',
    title: '樱花下的谎言',
    originalTitle: 'Lies Beneath the Sakura',
    type: 'tv',
    region: '日本',
    year: 2022,
    genres: ['悬疑', '爱情'],
    rating: 8.4,
    views: 6390000,
    duration: '全18集',
    director: '渡边理沙',
    actors: ['山崎翔', '长谷川唯', '井上隆'],
    synopsis: '一段看似完美的爱情，在樱花祭的夜里出现第一道裂痕。当真相层层剥开，每个人都发现，自己也在撒着不愿承认的谎。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20mystery%20romance%20drama%20poster%2C%20young%20woman%20under%20sakura%20tree%20looking%20away%20with%20hidden%20emotion%2C%20deep%20navy%20tones%20with%20soft%20amber%20blossom%20glow%2C%20moody%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-19-cover&orientation=portrait',
    dateAdded: '2022-04-08',
    tags: ['悬疑', '爱情', '反转'],
  },
  {
    id: 'm20',
    title: '湄南河畔',
    originalTitle: 'By the Chao Phraya',
    type: 'tv',
    region: '泰国',
    year: 2025,
    genres: ['剧情', '历史'],
    rating: 8.2,
    views: 4210000,
    duration: '全26集',
    director: '汶颂·塔',
    actors: ['阿披查·颂', '娜琳·帕', '素帕·温'],
    synopsis: '湄南河上的一户船家，在时代变迁中守住祖辈留下的摆渡生意。河水流过几代人，也流过他们的欢喜、离别与和解。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20thai%20historical%20family%20drama%20poster%2C%20wooden%20boat%20on%20the%20chao%20phraya%20river%20at%20golden%20dusk%20with%20temple%20silhouette%2C%20deep%20navy%20tones%20with%20warm%20amber%20sunset%2C%20nostalgic%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-20-cover&orientation=portrait',
    dateAdded: '2025-06-14',
    tags: ['年代', '家庭', '异域'],
  },
  {
    id: 'm21',
    title: '笑看风云',
    originalTitle: 'Laughing Through the Storm',
    type: 'tv',
    region: '香港',
    year: 2019,
    genres: ['喜剧', '剧情'],
    rating: 8.5,
    views: 5860000,
    duration: '全32集',
    director: '麦家辉',
    actors: ['周国安', '李绮华', '张学明'],
    synopsis: '一家开在街角四十年的茶餐厅面临拆迁。老板与老街坊们决定用自己的方式，把最后的烟火气热闹地留在这条街上。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20hong%20kong%20warm%20comedy%20drama%20poster%2C%20cozy%20old%20hong%20kong%20cha%20chaan%20teng%20tea%20restaurant%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20neon%20and%20lantern%20glow%2C%20nostalgic%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-21-cover&orientation=portrait',
    dateAdded: '2019-07-22',
    tags: ['喜剧', '温情', '市井'],
  },
  {
    id: 'm22',
    title: '星空之城',
    originalTitle: 'City of Stars',
    type: 'movie',
    region: '中国',
    year: 2025,
    genres: ['科幻', '剧情'],
    rating: 8.7,
    views: 8990000,
    duration: '131分钟',
    director: '林宇峰',
    actors: ['程星野', '苏若', '高远'],
    synopsis: '在一座漂浮于云层之上的未来都市里，一名普通的维修师偶然发现了整座城市能源系统的秘密。她要做的，是选择安稳还是真相。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20chinese%20sci%20fi%20drama%20film%20poster%2C%20futuristic%20floating%20city%20above%20clouds%20at%20night%20with%20glowing%20amber%20lights%2C%20deep%20navy%20sky%20tones%20with%20warm%20gold%20glow%2C%20epic%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-22-cover&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20chinese%20sci%20fi%20city%20scene%2C%20futuristic%20metropolis%20floating%20above%20glowing%20cloud%20sea%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20light%20streaks%2C%20epic%20atmospheric%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=movie-22-hero&orientation=landscape',
    dateAdded: '2025-10-03',
    tags: ['科幻', '未来', '悬疑'],
  },
  {
    id: 'm23',
    title: '深海回响',
    originalTitle: 'Echo of the Deep',
    type: 'movie',
    region: '日本',
    year: 2024,
    genres: ['科幻', '悬疑'],
    rating: 8.6,
    views: 6920000,
    duration: '127分钟',
    director: '中岛凉',
    actors: ['佐久间零', '堀北真希', '远藤诚'],
    synopsis: '深海研究站的声呐捕捉到一段无法解释的规律信号。当研究员一步步接近源头，他发现真正需要面对的，是记忆深处最不想触及的答案。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20japanese%20deep%20sea%20sci%20fi%20film%20poster%2C%20underwater%20research%20station%20window%20with%20glowing%20amber%20lights%20in%20dark%20ocean%2C%20deep%20navy%20abyss%20tones%2C%20mysterious%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-23-cover&orientation=portrait',
    dateAdded: '2024-09-06',
    tags: ['科幻', '深海', '烧脑'],
  },
  {
    id: 'm24',
    title: '春日光影',
    originalTitle: 'Spring Light',
    type: 'movie',
    region: '台湾',
    year: 2023,
    genres: ['青春', '剧情'],
    rating: 8.3,
    views: 3670000,
    duration: '108分钟',
    director: '黄以柔',
    actors: ['陈昊', '林以晴', '高柏安'],
    synopsis: '高中最后一个春天，摄影社的三个少年决定办一场属于自己的影展。在快门声与离别之间，他们第一次认真面对长大这件事。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20taiwanese%20coming%20of%20age%20film%20poster%2C%20teenagers%20with%20camera%20on%20a%20sunlit%20campus%20field%20in%20spring%2C%20deep%20navy%20shadows%20with%20warm%20amber%20golden%20light%2C%20youthful%20atmospheric%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-24-cover&orientation=portrait',
    dateAdded: '2023-03-17',
    tags: ['青春', '校园', '治愈'],
  },
];